/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-19 15:06:40
 * @LastEditors: sj
 * @LastEditTime: 2022-08-22 11:19:56
 */

import { Button, Popconfirm, Space, Switch, TableColumnType, Tooltip } from 'antd'
import moment from 'moment'
import React from 'react'
import { DateTimeFormatSimple } from '../../models/datetime'
import { decrypt } from '../../models/m'

export const ColumnsForWaitUpload = (
  onClick: (id: number, action: any, t?: any) => void,
  startIndex: number,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: '4rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '患者姓名',
      align: 'center',
      dataIndex: 'patientName',
    },
    {
      title: '联系方式',
      align: 'center',
      dataIndex: 'patientPhone',
      render: (_, r) => {
        return r?.patientPhone ? decrypt(r?.patientPhone) : '-'
      },
    },

    {
      title: '接诊医生',
      align: 'center',
      dataIndex: 'treatmentDoctorName',
    },
    {
      title: '开方时间',
      align: 'center',
      dataIndex: 'createTime',
    },
    {
      title: '诊断',
      align: 'center',
      dataIndex: 'disease',
    },
    {
      title: '创建人',
      align: 'center',
      dataIndex: 'operateUserName',
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'id',
      key: 'id',
      width: '6rem',
      render: function Element(_, t) {
        {
          return <Space>
             <Button type='primary' size='small' onClick={() => {
              onClick(t.id, 'audit', t)
            }}>
              审核
            </Button>
            <Button type='primary' size='small' onClick={() => {
              onClick(t.id, 'reject', t)
            }}>
              打回
            </Button>
            <Button type='primary' danger size='small' onClick={() => {
              onClick(t.id, 'uploadOne', t)
            }}>
              上传
            </Button>
          </Space>
        } 
      },
    },
  ]
}
